import {Component, EventEmitter, Input, Output, SimpleChanges} from '@angular/core';
import {Competitor, Lookups, Race, RaceSettings} from "@model";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {AbstractComponent} from "../abstract.component";
import {ManageCompetitorErrorCodes} from "../../model/manage-competitor-error-codes";
import {take} from "rxjs/operators";
import {required} from "@utility";

@Component({
  selector: 'app-edit-competitor-race',
  templateUrl: './edit-competitor-race.component.html',
  styleUrl: './edit-competitor-race.component.scss'
})
export class EditCompetitorRaceComponent extends AbstractComponent{
  @Input({ required: true }) title: string = "";
  @Input() confirmButtonTitle?: string;
  @Input({ required: true }) competitor?: Competitor;
  @Input() races: Race[] = [];
  @Input({ required: true }) languages: Lookups[] = [];
  @Input() errorCode: ManageCompetitorErrorCodes | undefined;


  @Output() onSave = new EventEmitter<Competitor>();

  raceSettings: RaceSettings | undefined;

  inputForm = new FormGroup({
    selected: new FormControl(),
    startNumber: new FormControl(),
    startBlock: new FormControl(),
  });

  constructor(public activeModal: NgbActiveModal, public formBuilder: FormBuilder) {
    super();
  }

  ngOnInit(): void {
    this.subscriptions.push(this.inputForm.controls.selected.valueChanges.subscribe(raceId => {
      this.raceSettings = this.races.find(race => race.id === raceId)?.raceSettings;
      this.inputForm.controls.startNumber.setValue(this.competitor?.startNumber);
      this.inputForm.controls.startBlock.setValue(this.raceSettings?.blockStart ? this.competitor?.startBlock : undefined);
    }))
    this.inputForm.controls.startNumber.valueChanges.subscribe(() => {
      this.updateValidators();
      this.inputForm.controls.startBlock.markAsUntouched();
    });

    this.inputForm.controls.startBlock.valueChanges.subscribe(() => {
      this.updateValidators();
      this.inputForm.controls.startNumber.markAsUntouched();

    });
    this.inputForm.controls.startNumber.setValue(this.competitor?.startNumber);
    this.inputForm.controls.startBlock.setValue(this.raceSettings?.blockStart ? this.competitor?.startBlock : undefined);
    this.inputForm.controls.selected.setValue(this.competitor?.raceId);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['errorCode']?.currentValue !== changes['errorCode']?.previousValue) {
      this.displayError(changes['errorCode']?.currentValue)
    }
  }

  displayError(errorCode: ManageCompetitorErrorCodes | undefined) {
    this.errorCode = errorCode;
    const isStartBlockError = errorCode === ManageCompetitorErrorCodes.START_BLOCK_LIMIT || errorCode === ManageCompetitorErrorCodes.START_BLOCK_MISSING;
    const errorControl = isStartBlockError ? 'startBlock' : 'startNumber';
    const otherControl = isStartBlockError ? 'startNumber' : 'startBlock';

    this.inputForm.controls[errorControl].setErrors(null);
    this.inputForm.controls[otherControl].setErrors(null);

    if (errorCode) {
      this.inputForm.controls[errorControl].setErrors({[errorControl]: true});

      this.subscriptions.push(
          this.inputForm.controls[errorControl].valueChanges.pipe(take(1)).subscribe(() => {
            this.inputForm.controls[errorControl].setErrors(null);
          })
      );
    }
  }

  updateValidators() {
    const startNumberValue = this.inputForm.controls.startNumber.value;
    const startBlockValue = this.inputForm.controls.startBlock.value;

    if ((startNumberValue || startBlockValue) && this.raceSettings?.blockStart) {
      this.inputForm.controls.startNumber.setValidators([required]);
      this.inputForm.controls.startBlock.setValidators([required]);
    } else {
      this.inputForm.controls.startNumber.removeValidators([required]);
      this.inputForm.controls.startBlock.removeValidators([required]);
    }
    this.inputForm.controls.startNumber.updateValueAndValidity({onlySelf: true, emitEvent: false});
    this.inputForm.controls.startBlock.updateValueAndValidity({onlySelf: true, emitEvent: false});
  }


  onConfirmClick(): void {
    if (!this.competitor || this.inputForm.invalid || this.competitor.raceId === this.inputForm.controls.selected.value) {
      this.markAllAsTouched(this.inputForm);
      return;
    };
    const competitor: Competitor = { ...this.competitor };

    if (this.inputForm.controls.startNumber.value === "") {
      this.inputForm.controls.startNumber.setValue(undefined, {onlySelf: true, emitEvent: false})
    }
    if (this.inputForm.controls.startBlock.value === "") {
      this.inputForm.controls.startBlock.setValue(undefined, {onlySelf: true, emitEvent: false})
    }
    competitor.raceId = this.inputForm.controls.selected.value;
    competitor.startNumber = this.inputForm.controls.startNumber.value;
    competitor.startBlock = this.inputForm.controls.startBlock.value;
    this.onSave.emit(competitor);
  }


  onDismissClick(): void {
    this.activeModal.dismiss();
  }
}
